import React, { useEffect, useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './RegisterHeader.scss';
// import userService from '../../../../../Services/userService';
import Cachedfunction from '../../../../../Helpers/cachedfunction';
import psc from '../../../../../Assets/images/psc_logo.png';
import police from '../../../../../Assets/images/logo.png';
import nig_logo from '../../../../../Assets/images/q.png';
import CurrentStageButton from './CurrentStageButton';
import bucketService from '../../../../../Services/bucketService';

// Define the shape of your menu data
interface MenuSection {
  switch: number;
}

interface MenuData {
  registration: MenuSection;
  pscreen: MenuSection;
  ainterview: MenuSection;
  aptitude: MenuSection;
  medical: MenuSection;
  institution: MenuSection;
  mergedAdmissionSettings: any
}

const RegisterHeader = () => {
  const [resData, setResData] = useState<MenuData | null>(null);
  // --- RESTORED LOGIC ---
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // 1. Scroll Detection (Transparent -> White)
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 2. Close mobile menu when route changes
  useEffect(() => {
    setIsNavExpanded(false);
  }, [location]);

  // 3. Data Fetching Logic
  const fetchMenuData = useCallback(async () => {
    try {
      const response = await bucketService.statusInfo();
      const data = response.data;
      Cachedfunction(data);
      setResData(data);
    } catch (error) {
      console.error('Failed to fetch menu data:', error);
    }
  }, []);

  useEffect(() => {
    const storedItem: string | null = localStorage.getItem('MENU_COMMAND');
    const toJSON = JSON.parse(storedItem as string) || ""
    const dateSInceEponch = Date.now()
    // console.log('CHECK THIS OUT:', toJSON.data)
    // const geater = toJSON.expirationTime > dateSInceEponch
    // console.log('GEATER', geater)
    if (toJSON.expirationTime < dateSInceEponch) {
      try {
        const parsedItem = JSON.parse(storedItem as string);
        // Simplified TTL check
        setResData(parsedItem.data || parsedItem);
      } catch (e) {
        fetchMenuData();
      }
    } else {
      fetchMenuData();
    }
  }, []);

  return (
    // Apply 'scrolled' class when user scrolls down
    <header className={`register-header shadow container ${scrolled ? 'scrolled' : ''}`}>
      <div className='ost-multi-header'>
        <nav className='site-header navbar navbar-expand-lg'>
          <div className='container sticky-header main-bar-wraper'>

            {/* --- LOGO SECTION (Logos Overlapping Flag) --- */}
            <div className='d-flex align-items-center  position-relative'>

              {/* Layer 1 (Bottom): Nigeria Coat of Arms */}
              <div className='flag-container'>
                <img
                  src={nig_logo}
                  alt='Nigeria Coat of Arms'
                  className='coat-arms'
                />
              </div>

              {/* Layer 2 (Top): Agency Logos */}
              <div className='logo-group '>
                <img
                  src={psc}
                  alt='PSC'
                  className='logo-round'
                />
                <img
                  src={police}
                  alt='Police'
                  className='logo-round'
                />
              </div>

            </div>

            {/* --- HAMBURGER BUTTON (Active) --- */}
            <button
              className='navbar-toggler'
              type='button'
              onClick={() => setIsNavExpanded(!isNavExpanded)}
            >
              <i
                className={`fa ${isNavExpanded ? 'fa-times' : 'fa-bars'} fa-2x text-dark`}
              ></i>
            </button>

            {/* --- LINKS & BUTTONS --- */}
            <div
              className={`collapse  d-lg-flex justify-content-between navbar-collapse ${isNavExpanded ? 'show' : ''}`}
              id='navbarNav'
            >
              <ul className='navbar-nav ms-auto  align-items-center'>
                <li className='nav-item'>
                  <a
                    className='nav-link'
                    href='https://npfapplication.psc.gov.ng'
                  >
                    Home
                  </a>
                </li>
  <li>
                  <Link to='/faq' className='nav-link dropdown-toggle' role='button' data-toggle='dropdown'>FAQ</Link>
                </li>
                                <li>
                  <Link to='/data-protection-privacy' className='nav-link dropdown-toggle' role='button' data-toggle='dropdown'>Privacy Policy</Link>
                </li>
                {resData?.registration?.switch === 1 && (
                  <li className='nav-item dropdown'>
                    <a className='nav-link dropdown-toggle' href='/' role='button' data-toggle='dropdown'>Enrollment</a>
                    <div className='dropdown-menu'>
                      <Link className='dropdown-item' to='/apply'>Start Application</Link>
                      <Link className='dropdown-item' to='/guideline'>How to Apply</Link>
                      {/* <Link className='dropdown-item' to=''>Print Slip</Link> */}
                      {/* <a className='dropdown-item' href='/media/GUARANTOR-FORM-PSC.pdf' target='_blank' rel='noopener noreferrer'>Download Guarantor Form</a> */}
                    </div>
                  </li>
                )}

                {resData?.pscreen?.switch === 1 && (
                  <li className='nav-item dropdown'>
                    <a className='nav-link dropdown-toggle' href='#' role='button' data-toggle='dropdown'>Physical Screening</a>
                    <div className='dropdown-menu'>
                      <Link className='dropdown-item' to='/physical-document-credentials'>Print Screen Schedule</Link>
                      {/* <Link className='dropdown-item' to='/physical-screening-acknowlegement'>Print Screen Acknowledgment</Link> */}
                      <Link className='dropdown-item' to='/status-upload-request'>Request for Screened Upload</Link>
                    </div>
                  </li>
                )}

                {resData?.aptitude?.switch === 1 && (
                  <li className='nav-item dropdown'>
                    <a className='nav-link dropdown-toggle' href='#' role='button' data-toggle='dropdown'>Aptitude/Interview</a>
                    <div className='dropdown-menu'>
                      <Link className='dropdown-item' to='/print-aptitude-slip'>Print Aptitude Slip</Link>
                      {/* <Link className='dropdown-item' to='/print-aptitude-slip'>Print Specialist Interview Slip</Link> */}
                      <Link className='dropdown-item' to='/report-wrong-schedule'>Report Wrong Schedule</Link>
                    </div>
                  </li>
                )}

                {resData?.medical?.switch === 1 && (
                  <li className='nav-item dropdown'>
                    <a className='nav-link dropdown-toggle' href='#' role='button' data-toggle='dropdown'>Medical</a>
                    <div className='dropdown-menu'>
                      <Link className='dropdown-item' to='/medical-print-slip'>Print Medical Slip</Link>
                      <Link className='dropdown-item' to='/status-nin-medical'>Medical Status</Link>
                      <Link className='dropdown-item' to='/report-wrong-schedule-medical'>Report Wrong Schedule</Link>
                    </div>
                  </li>
                )}

                {resData?.institution?.switch === 1 && (
                  <li className='nav-item dropdown'>
                    <a className='nav-link dropdown-toggle' href='#' role='button' data-toggle='dropdown'>Recruit & Institution</a>
                    <div className='dropdown-menu'>
                      <Link className='dropdown-item' to='/college-slip'>Print Slip</Link>
                      <Link className='dropdown-item' to='/report-wrong-schedule-admission'>Report Wrong Schedule</Link>
                      <Link className='dropdown-item' to='/report-rejection'>Report Rejection</Link>
                    </div>
                  </li>
                )}
              </ul>

              {/* ACTION BUTTONS */}
              <div className="header-actions d-flex align-items-center gap-3 ms-lg-4 mt-3 mt-lg-0">
                 <Link to="/print-slip" className="btn-signup mx-1">⁠Print Submission Slip</Link>
                 <a href="/media/GUARANTOR-FORM-PSC.pdf" target='_blank' rel='noopener noreferrer' className="btn-gform  mx-1">Download Guarantor Form</a>
                 {resData?.mergedAdmissionSettings?.activeExercise && <CurrentStageButton currentStage={resData?.mergedAdmissionSettings?.activeExercise}/>}
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default RegisterHeader
